var escape = require("../../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".warning-img[data-v-37063338]{height:50px}.btn-bg1[data-v-37063338]{background-image:url(" + escape(require("../../../assets/images/workAPicture/btn-bg-image1.png")) + ");background-size:100% 100%;background-repeat:no-repeat}", ""]);

// exports
